import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { AccountInformation } from '../interfaces/account-information.interface';
import { ACCOUNT_ENDPOINT, SUCCESS_MANAGER_ENDPOINT } from '../app.constants';
import { Manager } from '../interfaces/manager.interface';

@Injectable({
    providedIn: 'root'
})

export class AccountService {

    constructor(
        private http: HttpClient,
    ) {}

    getAccountInformation(): Observable<AccountInformation>  {
        return this.http.get<AccountInformation>(ACCOUNT_ENDPOINT);
    }

    getSuccessManager(): Observable<HttpResponse<Manager>> {
        return this.http.get<Manager>(SUCCESS_MANAGER_ENDPOINT, {
            observe: 'response'
        });
    }
}

